import {
  GET_CREDIT_CARDS,
  GET_CREDIT_CARDS_FAIL,
  GET_CREDIT_CARDS_SUCCESS,
  CREATE_CREDIT_CARD,
  CREATE_CREDIT_CARD_FAIL,
  CREATE_CREDIT_CARD_SUCCESS,
  GET_CREDIT_CARD,
  GET_CREDIT_CARD_SUCCESS,
  GET_CREDIT_CARD_FAIL,
  UPDATE_CREDIT_CARD,
  UPDATE_CREDIT_CARD_SUCCESS,
  UPDATE_CREDIT_CARD_FAIL,
  DELETE_CREDIT_CARD,
  DELETE_CREDIT_CARD_SUCCESS,
  DELETE_CREDIT_CARD_FAIL,
  CLEAR_CREDIT_CARD_DETAILS
} from './constants';

export const initialState = {
  loading: false,
  creditCards: null,
  creditCard: null,
  error: {},
  params: null
};

function creditCardReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CREDIT_CARDS:
      return {
        ...state,
        error: {},
        loading: true,
        // Persist the last fetch params so the saga can refetch with the
        // same page/size after create/update (otherwise the post-mutation
        // GET drops back to page 1 — PLA-8612).
        params: action.payload
      };
    case GET_CREDIT_CARDS_SUCCESS:
      return {
        ...state,
        error: {},
        loading: false,
        creditCards: action?.payload || null
      };
    case GET_CREDIT_CARDS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case CREATE_CREDIT_CARD:
      return {
        ...state,
        loading: true,
        error: {}
      };
    case CREATE_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        creditCard: action.payload.data
      };
    case CREATE_CREDIT_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case GET_CREDIT_CARD:
      return {
        ...state,
        loading: true,
        error: {}
      };
    case GET_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        creditCard: action.payload.data.data
      };
    case GET_CREDIT_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case UPDATE_CREDIT_CARD:
      return {
        ...state,
        loading: true,
        error: {}
      };
    case UPDATE_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        creditCard: action.payload.data
      };
    case UPDATE_CREDIT_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case DELETE_CREDIT_CARD:
      return {
        ...state,
        loading: true,
        error: {}
      };
    case DELETE_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        creditCards: {
          ...state.creditCards,
          data: state.creditCards.data.filter(card => card.id !== action.payload)
        }
      };
    case DELETE_CREDIT_CARD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case CLEAR_CREDIT_CARD_DETAILS:
      return {
        ...state,
        creditCard: null,
        error: null
      };
    default:
      return state;
  }
}

export default creditCardReducer;
